'use strict';

module.exports = {
    HIDDEN: 'hidden',
    ACTIVE: 'active',
    REQUIRED: 'required',

    STEPPER: '.stepper__step',
    STEPPER_ROLE: '.stepper__role',
    STEPPER_ROLE_TITLE: '.stepper__h3',
    STEPPER_ROLE_DESCRIPTION: '.stepper__subtitle',
    STEPPER_STEP_ACIVE: '.stepper__step_active',
    _STEPPER_STEP_ACIVE: 'stepper__step_active',
    STEPPER_INFO_DISABLED: '.stepper__info_disabled',
    _STEPPER_INFO_DISABLED: 'stepper__info_disabled',
    _LAST_STEP_ACTIVE: 'last-step-active',
    _LAST_STEP_WAS_ACTIVE: 'last-step-was-active',


    UPLOADER_ACTIVE: '.uploader__label_active',
    UPLOADER_FILENAME: '.uploader__filename',
    _UPLOADER_INIT: 'uploader__label_initial',
    _UPLOADER_ACTIVE: 'uploader__label_active',
    _UPLOADER_FILENAME: 'uploader__filename',
    _UPLOADER_REMOVE: 'uploader__remove-file',
    UPLOADER_UPLOADED: 'm-file_uploaded',

    _CAMERA_ACTIVE: 'camera__label_active',
};
